import { useEffect, useState } from 'react';

const useGetLocalStorage = (data: string): string | null => {
  const [localStorageProps, getLocalStorageProps] = useState<string | null>(
    null
  );
  useEffect(() => {
    if (typeof window !== undefined) {
      getLocalStorageProps(localStorage.getItem(data));
    }
  }, [data]);

  return localStorageProps;
};

export default useGetLocalStorage;
